import { render, staticRenderFns } from "./OfferText.vue?vue&type=template&id=a8186730&scoped=true"
import script from "./OfferText.vue?vue&type=script&lang=js"
export * from "./OfferText.vue?vue&type=script&lang=js"
import style0 from "./OfferText.vue?vue&type=style&index=0&id=a8186730&prod&lang=scss"
import style1 from "./OfferText.vue?vue&type=style&index=1&id=a8186730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8186730",
  null
  
)

export default component.exports